import logo from 'assets/images/logo.png';
import * as S from './style';

export function Logo() {
  return <S.Logo src={logo} alt="DevIn" />;
}
